document.addEventListener('click', (event) => {
  const prevBtn = event.target.closest('.shop-best-sellers__arrow--prev');
  const nextBtn = event.target.closest('.shop-best-sellers__arrow--next');
  if (!prevBtn && !nextBtn) return;

  const container = event.target.closest('.shop-best-sellers');
  if (!container) return;

  const track = container.querySelector('.shop-best-sellers__grid');
  if (!track) return;

  const firstCard = track.querySelector('.shop-best-sellers__card-wrapper');
  const scrollAmount = firstCard ? firstCard.getBoundingClientRect().width + 12 : 260;

  track.scrollBy({ left: prevBtn ? -scrollAmount : scrollAmount, behavior: 'smooth' });
});
